/**
 * helper function that wraps an image URL with CSS `url()` syntax.
 *
 */
export function toCSSUrl(value?: string): string {
    return value ? `url(${value})` : '';
}
